import styled from 'styled-components';
import theme from '../../styles/theme';

export const Container = styled.div`
  display: flex;
  flex: 3;
  background-color: ${theme.accent};
  border-radius: 12px;
  padding: 10px 45px;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  height: 500px;
  max-width: 350px;
  align-self: center;
  position: relative;

  @media (max-width: 1024px) {
    width: calc(85% - 40px);
    max-width: 500px;
    margin: 25px;
  }
`;

export const SuccessFeedback = styled.div`
  display: flex;
  flex: 1;
  z-index: 2;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: ${theme.background};
  visibility: ${({ submitted }) => (submitted ? 'visible' : 'hidden')};
  position: absolute;
  top: 0;
  margin: auto;
  border-radius: 12px;
`;

export const SuccessText = styled.span`
  color: ${theme.primary};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  font-size: ${({ smallText }) => (smallText ? '16px' : '30px')};
  text-align: center;
  margin: 0px;
  margin: 30px 0;
  text-transform: uppercase;
`;

export const Title = styled.h2`
  color: ${theme.background};
  font-size: 26px;
  font-weight: bold;
  text-transform: uppercase;
`;

export const Form = styled.form`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
`;

export const SelectWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  align-self: center;
  margin: 10px 0;

  @media (max-width: 640px) {
    flex-direction: column;
    height: 105px;
  }
`;
